var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DateConverter } from "./../../../../converters/DateConverter";
export class SubmissionDeadlineConfiguration {
  constructor(_data) {
    /**
     */
    __publicField(this, "EFiling");
    /**
     */
    __publicField(this, "FilingExtension");
    /**
     */
    __publicField(this, "FrequencyType");
    /**
     */
    __publicField(this, "Id");
    /**
     */
    __publicField(this, "IsAvailable");
    /**
     */
    __publicField(this, "NextDueDate");
    /**
     */
    __publicField(this, "ReturnType");
    /**
     */
    __publicField(this, "ServiceCountryCode");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SubmissionDeadlineConfiguration
     */
    __publicField(this, "$type", "V1.SubmissionDeadlineConfigurations.Search.SubmissionDeadlineConfiguration");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.EFiling = _data["EFiling"];
      this.FilingExtension = _data["FilingExtension"];
      this.FrequencyType = SubmissionDeadlineConfigurationFrequencyType[_data["FrequencyType"]];
      this.Id = _data["Id"];
      this.IsAvailable = _data["IsAvailable"];
      this.NextDueDate = DateConverter.from(_data["NextDueDate"]);
      this.ReturnType = SubmissionDeadlineConfigurationReturnType[_data["ReturnType"]];
      this.ServiceCountryCode = _data["ServiceCountryCode"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["EFiling"] = this.EFiling;
    _data["FilingExtension"] = this.FilingExtension;
    _data["FrequencyType"] = SubmissionDeadlineConfigurationFrequencyType[this.FrequencyType];
    _data["Id"] = this.Id;
    _data["IsAvailable"] = this.IsAvailable;
    _data["NextDueDate"] = DateConverter.toUtcDateString(this.NextDueDate);
    _data["ReturnType"] = SubmissionDeadlineConfigurationReturnType[this.ReturnType];
    _data["ServiceCountryCode"] = this.ServiceCountryCode;
    return _data;
  }
}
export var SubmissionDeadlineConfigurationFrequencyType = /* @__PURE__ */ ((SubmissionDeadlineConfigurationFrequencyType2) => {
  SubmissionDeadlineConfigurationFrequencyType2["Monthly"] = "Monthly";
  SubmissionDeadlineConfigurationFrequencyType2["Quarterly"] = "Quarterly";
  SubmissionDeadlineConfigurationFrequencyType2["QuarterlyShifted1"] = "QuarterlyShifted1";
  SubmissionDeadlineConfigurationFrequencyType2["QuarterlyShifted2"] = "QuarterlyShifted2";
  SubmissionDeadlineConfigurationFrequencyType2["BiMonthly"] = "BiMonthly";
  SubmissionDeadlineConfigurationFrequencyType2["FourMonthly"] = "FourMonthly";
  SubmissionDeadlineConfigurationFrequencyType2["SixMonthly"] = "SixMonthly";
  SubmissionDeadlineConfigurationFrequencyType2["Yearly"] = "Yearly";
  return SubmissionDeadlineConfigurationFrequencyType2;
})(SubmissionDeadlineConfigurationFrequencyType || {});
export var SubmissionDeadlineConfigurationReturnType = /* @__PURE__ */ ((SubmissionDeadlineConfigurationReturnType2) => {
  SubmissionDeadlineConfigurationReturnType2["PrimaryVAT"] = "PrimaryVAT";
  SubmissionDeadlineConfigurationReturnType2["SecondaryVAT"] = "SecondaryVAT";
  SubmissionDeadlineConfigurationReturnType2["ESL"] = "ESL";
  SubmissionDeadlineConfigurationReturnType2["VLS"] = "VLS";
  SubmissionDeadlineConfigurationReturnType2["IOSS"] = "IOSS";
  SubmissionDeadlineConfigurationReturnType2["Intrastat"] = "Intrastat";
  SubmissionDeadlineConfigurationReturnType2["OSS"] = "OSS";
  SubmissionDeadlineConfigurationReturnType2["LocalListing"] = "LocalListing";
  return SubmissionDeadlineConfigurationReturnType2;
})(SubmissionDeadlineConfigurationReturnType || {});
